import React from 'react';
import {Card, CardBody, CardTitle, Row, Col, Input} from 'reactstrap';
import {Colxx} from '../components/common/CustomBootstrap';
import Area from '../components/charts/Area';
import {keys, values} from 'lodash';
import {areaChart} from '../components/charts/util';
import {withTranslation} from 'react-i18next';
import Api from '../services/Api';
import Select from 'react-select';
import {getDatePickerProps, selectStyles} from '../helpers/Utils';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import {DateTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import i18n from '../services/i18n';
import JalaliUtils from '@date-io/jalaali';
import MomentUtils from '@date-io/moment';
import {store} from '../AppRenderer';
import moment from 'moment';
import fa_IR from "../constants/locales";

class DepositsChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      from: null,
      to: null,
      token: 'TMN',
      mode: 'WEEKDAYS',
      loading: true,
    };
    this.modeOptions = [
      {label: props.t('WEEKDAYS'), value: 'WEEKDAYS'},
      {label: props.t('HOURLY'), value: 'HOURLY'},
    ];
    this.tokenOptions = store.getState().general.tokens.map(token => ({
      label: token.localeName, value: token.symbol
    }));
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    const {token, mode, from, to} = this.state;
    this.setState({
      loading: true,
    });
    try {
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/filterable-private-statistics',
        null,
        {
          params: {
            token,
            mode,
            from: from ? moment(from).toISOString() : null,
            to: to ? moment(to).toISOString() : null,
          },
          cancelToken: null,
        }
      );
      this.setState({
        data: data.deposit[token],
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  onChangeToken = token => {
    this.setState({
      token: token.value,
    }, async () => {
      await this.fetchData();
    });
  };

  onChangeMode = mode => {
    this.setState({
      mode: mode.value,
    }, async () => {
      await this.fetchData();
    });
  };

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    }, async () => {
      await this.fetchData();
    });
  };

  render () {
    const {data, loading, token, mode, from, to} = this.state;
    const {t} = this.props;
    return (
      <ThemeProvider
        theme={createMuiTheme({
          typography: {
            fontFamily: 'IRANSans',
          }})
        }
      >
        <MuiPickersUtilsProvider
          utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
          locale={i18n.language}
        >
          <Row>
            <Colxx xxs="12" className="mb-4">
              <Card>
                <CardBody>
                  <CardTitle className="text-large text-primary">
                    {t('Deposits')}
                  </CardTitle>
                  <Row className="mb-5">
                    <Col>
                      <span>{t('Token')}</span>
                      <Select
                        className="w-100"
                        styles={selectStyles}
                        value={this.tokenOptions.find(option => option.value === token)}
                        onChange={this.onChangeToken}
                        options={this.tokenOptions}
                        placeholder={t('Select')}
                      />
                    </Col>
                    <Col>
                      <span>{t('Mode')}</span>
                      <Select
                        className="w-100"
                        styles={selectStyles}
                        value={this.modeOptions.find(option => option.value === mode)}
                        onChange={this.onChangeMode}
                        options={this.modeOptions}
                        placeholder={t('Select')}
                      />
                    </Col>
                    <Col>
                      <span>{t('start date')}</span>
                      <DateTimePicker
                        {...getDatePickerProps()}
                        value={from}
                        TextFieldComponent={props => <Input className="datePickerInput" {...props} />}
                        onChange={date => {
                          this.handleDateChange('from', date);
                        }}
                      />
                    </Col>
                    <Col>
                      <span>{t('end date')}</span>
                      <DateTimePicker
                        {...getDatePickerProps()}
                        value={to}
                        TextFieldComponent={props => <Input className="datePickerInput" {...props} />}
                        onChange={date => {
                          this.handleDateChange('to', date);
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className='position-relative' style={{height: '360px'}}>
                    {loading && <div className='loading position-absolute align-self-center'/>}
                    <Area
                      shadow
                      data={{
                        labels: keys(data).map(label => t(label)),
                        datasets: [{
                          ...areaChart(1),
                          data: values(data).map(value => Math.abs(value)),
                        }],
                      }}
                    />
                  </Row>
                </CardBody>
              </Card>
            </Colxx>
          </Row>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    );
  }
}

export default withTranslation()(DepositsChart);
